import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex items-center" }
const _hoisted_2 = { class: "flex flex-col ml-2 mr-2" }
const _hoisted_3 = { class: "font-sourcesanspro-semibold text-sm text-white/50 leading-none" }
const _hoisted_4 = { class: "flex items-center" }
const _hoisted_5 = { class: "font-sourcesanspro-semibolditalic text-m2 leading-none" }
const _hoisted_6 = { class: "flex items-center checkbox-container" }
const _hoisted_7 = { class: "w-full" }
const _hoisted_8 = {
  key: 0,
  class: "flex items-center"
}
const _hoisted_9 = {
  for: "userTicketHolder",
  class: "font-sourcesanspro-semibolditalic text-white text-sm"
}
const _hoisted_10 = { class: "relative mb-4" }
const _hoisted_11 = {
  key: 0,
  class: "flex grow items-center justify-between h-[55px] mr-2 px-4 py-2 rounded-full border border-anykrowd-gray/20 background-anykrowd-gray mb-4"
}
const _hoisted_12 = { class: "flex" }
const _hoisted_13 = { class: "font-sourcesanspro-semibold text-base2 text-white" }

import { ref, watch, onMounted, nextTick } from 'vue';
import { IonButton, IonIcon } from '@ionic/vue';
import { checkmarkOutline, chevronForwardOutline, chevronDownOutline, ticketOutline, closeOutline } from 'ionicons/icons';
import CheckboxInput from '@/shared/components/sign-up-forms/CheckboxInput.vue';
import { useI18n } from 'vue-i18n';
import { useForm } from 'vee-validate';
import * as yup from 'yup';

import { Cart } from '@/shared/interfaces/cart';
import { useCart } from '@/modules/shop/composables/useCart';
import useUserProfile from '@/modules/profile/composables/useUserProfile';
import TextInput from '@/shared/components/sign-up-forms/TextInput.vue';
import { EMAIL_REGX } from '@/shared/constants/email';
import useTenant from '@/shared/composables/useTenant';
import { useAuthStore } from '@/stores/auth/authStore';


export default /*@__PURE__*/_defineComponent({
  __name: 'EventsItemMemberAdder',
  props: {
	shouldBlockChanges: { type: Boolean, default: false },
	cartItem: { type: Object as () => Cart, required: true },
	cartItemProductId: { type: Number, required: true },
	cartItemIndex: { type: Number, required: true },
	eventId: { type: Number, required: true },
},
  setup(__props) {

const props = __props;

const { t } = useI18n();
const isOpen = ref(false);
const { updateCartAdditionalInfoByIndex } = useCart();
const { getUserProfile } = useUserProfile();
const { userProfile } = getUserProfile();
const { getTenantConfigAndStyles } = useTenant();
const { tenantConfig } = getTenantConfigAndStyles();
const ticketHolderName = ref('');
const ticketHolderEmail = ref('');
const isUserTicketHolder = ref(false);
const { isAuthenticated } = useAuthStore();

// **Validation Schema**
const validationSchema = yup.object({
	memberEmail: yup.string().required().label(t('events.tickets.add_members.email_label')).matches(EMAIL_REGX, t('events.tickets.add_members.errors.email')),
	memberFullName: yup.string().required().label(t('events.tickets.add_members.full_name_label')),
});

// **Initialize Form**
const { meta, validate, setFieldValue, values, resetForm } = useForm({
	validationSchema,
	initialValues: {
		memberFullName: '',
		memberEmail: '',
	},
});

onMounted(async () => {
	if (props.cartItemIndex === 0 && tenantConfig && tenantConfig.value && !tenantConfig.value.enable_full_guest_mode && isAuthenticated()) {
		await toggleAssignToMe();
	} else if (props.cartItem.additionalInfo?.name) {
		ticketHolderName.value = props.cartItem.additionalInfo.name;
		ticketHolderEmail.value = props.cartItem.additionalInfo.email;
	}
});

const toggleAssignToMe = async () => {
	ticketHolderName.value = props.cartItem.additionalInfo?.name || userProfile.value?.full_name || '';
	ticketHolderEmail.value = props.cartItem.additionalInfo?.email || userProfile.value?.email || '';
	isUserTicketHolder.value = !isUserTicketHolder.value;

	if (isUserTicketHolder.value) {
		// Wait for Vue updates before setting values
		setTimeout(() => {
			setFieldValue('memberFullName', ticketHolderName.value);
			setFieldValue('memberEmail', ticketHolderEmail.value);
		}, 1000);
	} else {
		setFieldValue('memberFullName', '');
		setFieldValue('memberEmail', '');
		ticketHolderName.value = '';
		ticketHolderEmail.value = '';
	}

	// **Ensure auto-save on first render if fields were empty**
	if (!props.cartItem.additionalInfo?.name) {
		updateCartAdditionalInfoByIndex(props.cartItemIndex, {
			name: ticketHolderName.value,
			email: ticketHolderEmail.value,
		});
	}
};

// **Handle Form Submission**
const onSubmit = async (event: Event) => {
	event.preventDefault();
	const isValid = await validate();
	if (isValid.valid) {
		ticketHolderName.value = values.memberFullName;
		ticketHolderEmail.value = values.memberEmail;
		await updateCartAdditionalInfoByIndex(props.cartItemIndex, {
			name: values.memberFullName,
			email: values.memberEmail,
		});
	}
};

// **Prevent Accordion Toggle When Clicking Checkbox**
const toggleAccordion = (event: Event) => {
	if (!(event.target as HTMLElement).closest('.checkbox-container')) {
		isOpen.value = !isOpen.value;
	}
};

// Remove member
const removeMember = () => {
	isUserTicketHolder.value = false;
	ticketHolderName.value = '';
	ticketHolderEmail.value = '';

	updateCartAdditionalInfoByIndex(props.cartItemIndex, {
		...props.cartItem.additionalInfo,
		name: null,
		email: null,
		user_id: null,
	});
	resetForm();
};

return (_ctx: any,_cache: any) => {
  const _component_ion_accordion = _resolveComponent("ion-accordion")!
  const _component_ion_accordion_group = _resolveComponent("ion-accordion-group")!

  return (_openBlock(), _createBlock(_component_ion_accordion_group, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_accordion, { class: "mb-4 items-start justify-between backdrop-blur-3xl bg-[#3f3e4a] rounded-lg" }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: "flex w-full justify-between h-[70px] px-4 py-2 cursor-pointer",
            slot: "header",
            onClick: toggleAccordion
          }, [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_unref(IonIcon), {
                class: _normalizeClass([!ticketHolderName.value ? 'text-white' : 'text-anykrowd-ticket-check-green', "w-[22px] h-[22px] py-2 rounded-full"]),
                icon: !ticketHolderName.value ? _unref(ticketOutline) : _unref(checkmarkOutline)
              }, null, 8, ["class", "icon"]),
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("span", _hoisted_3, _toDisplayString(__props.cartItem?.product.name) + " :", 1),
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("span", _hoisted_5, _toDisplayString(ticketHolderName.value || _unref(t)('components.events_item_member_adder.empty')), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_unref(IonIcon), {
                icon: isOpen.value ? _unref(chevronDownOutline) : _unref(chevronForwardOutline),
                class: "text-white"
              }, null, 8, ["icon"])
            ])
          ]),
          _createElementVNode("div", {
            class: _normalizeClass([[{ 'flex': props.cartItem.additionalInfo.name }], "ion-padding border-t border-t-white/10 font-sourcesanspro-regular text-base2 font-color-text-50"]),
            slot: "content"
          }, [
            _withDirectives(_createElementVNode("div", _hoisted_7, [
              (_unref(tenantConfig) && !_unref(tenantConfig).enable_full_guest_mode && _unref(isAuthenticated)())
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createVNode(CheckboxInput, {
                      id: "userTicketHolder",
                      name: "userTicketHolder",
                      "container-class": "w-[20px]",
                      type: "checkbox",
                      defaultValue: isUserTicketHolder.value,
                      onClick: toggleAssignToMe
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("label", _hoisted_9, _toDisplayString(_unref(t)('components.events_item_member_adder.assign_to_me')), 1)
                      ]),
                      _: 1
                    }, 8, ["defaultValue"])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("form", {
                onSubmit: onSubmit,
                class: "w-full"
              }, [
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(TextInput, {
                    "wrapper-class": "flex flex-wrap justify-left item-center mb-2 border border-solid focus-within:background-white-15",
                    modelValue: ticketHolderName.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((ticketHolderName).value = $event)),
                    name: "memberFullName",
                    type: "text",
                    placeholder: _unref(t)('components.events_item_member_adder.memberFullName')
                  }, null, 8, ["modelValue", "placeholder"])
                ]),
                _createVNode(TextInput, {
                  "wrapper-class": "flex flex-wrap justify-left item-center mb-2 border border-solid focus-within:background-white-15",
                  modelValue: ticketHolderEmail.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((ticketHolderEmail).value = $event)),
                  name: "memberEmail",
                  type: "email",
                  placeholder: _unref(t)('components.events_item_member_adder.memberEmail')
                }, null, 8, ["modelValue", "placeholder"]),
                _createVNode(_unref(IonButton), {
                  type: "submit",
                  disabled: !_unref(meta).valid,
                  shape: "round",
                  class: "hover:rounded-full hover:bg-white"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('components.events_item_member_adder.save')), 1)
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ], 32)
            ], 512), [
              [_vShow, !props.cartItem.additionalInfo.name || !props.cartItem.additionalInfo.email]
            ]),
            (props.cartItem.additionalInfo.name && props.cartItem.additionalInfo.email)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _createVNode(_unref(IonIcon), {
                      class: "cursor-pointer mr-2",
                      icon: _unref(ticketOutline),
                      slot: "end"
                    }, null, 8, ["icon"]),
                    _createElementVNode("span", _hoisted_13, _toDisplayString(props.cartItem.additionalInfo.name), 1)
                  ]),
                  _createVNode(_unref(IonButton), {
                    class: "transparent ion-no-margin ion-no-padding",
                    shape: "round",
                    onClick: removeMember
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonIcon), {
                        class: "cursor-pointer",
                        icon: _unref(closeOutline)
                      }, null, 8, ["icon"])
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true)
          ], 2)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})